export enum Color {
  INVERTED = 'inverted',
  PRIMARY = 'primary',
}
